// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/Articles/components/EditArticleModal.css
// module id = 2065
// module chunks = 0